import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/icons'
import SvgIcon from '@/components/SvgIcon'
import '@/style/index.scss'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'default-passive-events'
import PageLayout from './components/PageLayout'
import Pagination from './components/Pagination'
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.component('svg-icon', SvgIcon)
app.component('PageLayout', PageLayout)
app.component('Pagination', Pagination)
app.use(ElementPlus, { locale: zhCn })
app.use(store).use(router).mount('#app')
